import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "viraai-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, date: new Date().toISOString() })
    );
    if (choice === "all") window.__initPostHog?.();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-20 md:bottom-5 left-20 right-4 md:left-auto md:right-5 z-[60] max-w-md rounded-2xl p-6"
          style={{
            background: "rgba(17,17,17,0.97)",
            backdropFilter: "blur(20px)",
            border: "1px solid rgba(201,168,76,0.25)",
            boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
          }}
          data-testid="cookie-consent-banner"
          role="dialog"
          aria-label="Cookie-Einstellungen"
        >
          <div className="flex items-start gap-3 mb-4">
            <Cookie className="w-5 h-5 text-[#C9A84C] shrink-0 mt-0.5" />
            <div>
              <p className="text-[#F5F5F7] font-semibold text-sm mb-1.5">
                Cookies & Datenschutz
              </p>
              <p className="text-[#86868b] text-xs leading-relaxed">
                Wir verwenden nur technisch notwendige Cookies, um die Website
                bereitzustellen. Optionale Cookies helfen uns, das Angebot zu
                verbessern. Details in unserer{" "}
                <Link
                  to="/datenschutz"
                  className="text-[#C9A84C] underline hover:text-[#E0C375]"
                  data-testid="cookie-consent-privacy-link"
                >
                  Datenschutzerklärung
                </Link>
                .
              </p>
            </div>
          </div>
          <div className="flex gap-2.5">
            <button
              onClick={() => decide("all")}
              className="flex-1 bg-[#C9A84C] text-[#0A0A0A] font-bold text-sm px-4 py-2.5 rounded-full hover:bg-[#E0C375] transition-colors duration-200"
              data-testid="cookie-consent-accept-all"
            >
              Alle akzeptieren
            </button>
            <button
              onClick={() => decide("essential")}
              className="flex-1 text-[#86868b] hover:text-[#F5F5F7] font-medium text-sm px-4 py-2.5 rounded-full border border-white/15 hover:border-white/30 transition-colors duration-200"
              data-testid="cookie-consent-essential-only"
            >
              Nur notwendige
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
